const ArticleListItem = () => import('../../components/article-list-item/index.vue');
const PreparednessShimmer = () => import('../../components/shimmers-screen/recovery-screen-shimmer.vue');

export default {
  name: 'PreparednessPage',

  components: {
    'list-item': ArticleListItem,
    'preparedness-shimmer': PreparednessShimmer
  },

  data() {
    return {
      isLoading: true
    };
  },

  computed: {
    list() {
      return this.$store.getters.getArticleList(10003);
    }
  },


 async created() {
  this.isLoading = true;

  await this.$store.dispatch('fetchArticles');

  this.$store.commit('setMenuItems', this.list);
  this.$store.commit('setMenuDetails', {
    title: 'Preparedness',
    slug: 'preparedness',
    back_url: '/action/operations'
  });

  this.isLoading = false;
}

};
